module.exports = __webpack_public_path__ + "static/img/offline_pay_small_info.4cc5894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/offline_pay_small_info.png
// module id = Lpqx
// module chunks = 18